// 主表格组件
export default {
  // 表格列名
  month: "月份",
  date: "日期",
  inflowAmount: "转入数量(万元)",
  outflowAmount: "转出数量(万元)",

  // 合计行
  total: "合计",

  // 转入转出统计
  totalInflowAmount: "转入总数量",
  totalOutflowAmount: "转出总数量",
  tenThousand: "万",
};
